<template>
<div>
    <Loading v-if="loading_pdf" />
    <button v-else  class="btn btn-sm btn-primary ml-2 mr-2" @click="init">
        <!--<span v-if="loading_pdf" class="spinner-border spinner-border-sm" role="status"></span> -->
        <font-awesome-icon icon="file-pdf"  /> PDF
    </button>
</div>
</template>

<script>
    import api from "@/mixins/api.js"

    export default {
        name: "PDF-button",
        mixins: [ api ],
        props: ['filter', 'unidade_id', 'type', 'data_head', 'data_body', 'title', 'datatable', 'external','consulta' , 'total'],

        data: () => { 
            return {
                loading_pdf: false,            
            }
        },

        methods: {
            init() {
                if ( this.type == "datatable" ){
                    this.post_datatable();
                }
            },

            async post_datatable() {
                this.loading_pdf = true
                var resultado = "";
                if(this.datatable == 'denuncia'){
                    resultado = await this.GET("Denuncia", `Paginate/0?datatable=${this.datatable}${this.filter}&unidade=${this.unidade_id}`);
                    this.consulta = resultado.result;
                    this.total = resultado.total;
                }
                if(this.datatable == 'Log_Use'){
                    resultado = await this.GET("Log/Use", `Paginate/0?datatable=${this.datatable}${this.filter}&unidade_id=${this.unidade_id}`);
                    this.consulta = resultado.result;
                    this.total = resultado.total;
                }
                if(this.datatable == 'Dialstatus'){
                    resultado = await this.GET("Dialstatus", `Paginate/0?datatable=${this.datatable}${this.filter}&UNIDADE_ID=${this.unidade_id}`);
                    this.consulta = resultado.result;
                    this.total = resultado.total;
                }
                if(this.datatable == 'Ramal'){
                    resultado = await this.GET("Ramal", `Paginate/0?datatable=${this.datatable}${this.filter}&UNIDADE_ID=${this.unidade_id}`);
                    this.consulta = resultado.result;
                    this.total = resultado.total;
                }

                
                const params = {
                    external: this.external,
                    usuario: this.$store.state.user.name,
                    datatable: this.datatable,
                    title: this.title,
                    filter: this.filter,
                    header: this.data_head,
                    body: this.data_body,
                    consulta: this.consulta,
                    total: this.total
                }

                const pdf = await this.POST("PDF/Datatable/New", params );
                this.open_pdf_tab(pdf);
                this.loading_pdf = false;
            },

            open_pdf_tab(pdf) {
                /*const pdfWindow = window.open("", "_blank");
                if(pdfWindow){
                    pdfWindow.document.write("<iframe width='100%' height='99%' src='data:application/pdf;base64, " + encodeURIComponent(pdf) + "'></iframe>")
                }*/
                const link = document.createElement("a");
                link.download = "relatorio.pdf";
                link.href = "data:application/pdf;base64, " + pdf ;
                link.click();
            }
        }
    }
</script>

<style>

</style>